export default "__VITE_ASSET__BJNuLuk8__"